/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _PlanState = {
  id: null,
  hotel_id: null,
  hotel_name: '',
  plan_code: '',
  pms_plan_code: '',
  name: '',
  breakfasts: [],
  lunches: [],
  dinners: [],
  activities: []
}

class PlanState extends Record(_PlanState) {
  mergeModel(model) {
    return this.merge(model)
  }
}

export { PlanState }
